/**
 * Job types (piece 29, *The field side: job types that pre-fill*; T390, T1710):
 * Settings › Work › Job Types, the pick on a Draft job and the job's planned
 * parts, kept beside the job type rules.
 */
export const JOB_TYPE_STRINGS = {
  'settings.jobTypes.title': 'Job Types',
  'settings.jobTypes.add': 'New Job Type',
  'settings.jobTypes.addTitle': 'New Job Type',
  'settings.jobTypes.editTitle': 'Edit Job Type',
  'settings.jobTypes.hint': 'A job type fills a Draft job with its labor lines, their skill levels and sub-skills, its planned parts and its checklist. The job keeps copies: editing a type never reaches a job it already filled.',
  'settings.jobTypes.none': 'No job types yet. Make the first with New Job Type.',
  'settings.jobTypes.inactive': 'Deactivated',
  'settings.jobTypes.name': 'Name',
  'settings.jobTypes.description': 'Description',
  'settings.jobTypes.minutes': 'Estimated Minutes',
  'settings.jobTypes.minutesHint': 'The booking window opens on this length when the job names the type.',
  'settings.jobTypes.noLength': 'No estimated length',
  'settings.jobTypes.template': 'Checklist Template',
  'settings.jobTypes.noTemplate': 'No checklist',
  'settings.jobTypes.training': 'Training the checklist asks for:',
  'settings.jobTypes.noTraining': 'The checklist cites no training.',
  'settings.jobTypes.tasks': 'Tasks',
  'settings.jobTypes.taskCount': 'tasks',
  'settings.jobTypes.taskOne': 'task',
  'settings.jobTypes.task': 'Task',
  'settings.jobTypes.taskDescription': 'What the Work Is',
  'settings.jobTypes.level': 'Skill Level',
  'settings.jobTypes.subSkillPick': 'Sub-Skill',
  'settings.jobTypes.subSkillAdd': 'Add Sub-Skill',
  'settings.jobTypes.subSkillRemove': 'Remove Sub-Skill',
  'settings.jobTypes.subSkillNone': 'No sub-skills',
  'settings.jobTypes.addTask': 'Add Task',
  'settings.jobTypes.removeTask': 'Remove Task',
  'settings.jobTypes.parts': 'Parts',
  'settings.jobTypes.partCount': 'parts',
  'settings.jobTypes.partOne': 'part',
  'settings.jobTypes.part': 'Part',
  'settings.jobTypes.quantity': 'Quantity',
  'settings.jobTypes.unit': 'Unit',
  'settings.jobTypes.addPart': 'Add Part',
  'settings.jobTypes.removePart': 'Remove Part',
  'workOrder.jobType.label': 'Job Type',
  'workOrder.jobType.none': 'No job type',
  'workOrder.jobType.inactive': 'Deactivated',
  'workOrder.jobType.pick': 'Pick Job Type',
  'workOrder.jobType.change': 'Change Job Type',
  'workOrder.jobType.pickTitle': 'Pick a Job Type',
  'workOrder.jobType.choice': 'Job Type',
  'workOrder.jobType.fills': 'Picking it writes its labor lines with their levels and sub-skills, its planned parts and its checklist onto this Draft. Each is a copy you can edit here.',
  'workOrder.jobType.appliedOnce': 'This job already names a job type. Saving records the new type and leaves the labor lines, the planned parts and the checklist as they stand.',
  'workOrder.jobType.noneMade': 'No active job type exists. An administrator makes them under Settings › Work › Job Types.',
  'workOrder.jobType.act': 'Pick',
  'workOrder.planned.title': 'Planned Parts',
  'workOrder.planned.hint': 'What the job expects to use. A planned part moves no stock and posts no cost until it is recorded fitted.',
  'workOrder.planned.none': 'No planned parts',
  'workOrder.planned.add': 'Add Planned Part',
  'workOrder.planned.addTitle': 'Add a Planned Part',
  'workOrder.planned.edit': 'Edit Planned Part',
  'workOrder.planned.editTitle': 'Edit a Planned Part',
  'workOrder.planned.remove': 'Remove',
  'workOrder.planned.fit': 'Record Fitted',
  'workOrder.planned.fromType': 'from the job type',
  'workOrder.planned.fitted': 'fitted of this item',
} as const;
